import { useState } from "react";
import { WordleWords } from "./WordleWords";
import './Wordle.css';

const WordleComponent = () => {
    const rNum = (num) => Math.floor(Math.random() * Math.floor(num) + 1);
    
    const [board1, setBoard1] = useState(['', '', '', '', '']);
    const [board2, setBoard2] = useState(['', '', '', '', '']);
    const [board3, setBoard3] = useState(['', '', '', '', '']);
    const [board4, setBoard4] = useState(['', '', '', '', '']);
    const [board5, setBoard5] = useState(['', '', '', '', '']);
    
    const [word, setWord] = useState(WordleWords[rNum(WordleWords.length - 1)].toUpperCase());
    const [guess, setGuess] = useState('');
    const [guesses, setGuesses] = useState([]);
    const [message, setMessage] = useState('');
    
    const handleSubmit = () => {
        const normalizedGuess = guess.trim().toUpperCase();

        if (guesses.includes(normalizedGuess)) return setMessage('You have already guessed that word');
        if (!/^[A-Z]{5}$/.test(normalizedGuess)) return setMessage('Word must be exactly 5 letters');
        
        const newBoard = normalizedGuess.split('');
        let board = null;
        
        if (board1[0] === '') board = 1;
        else if (board2[0] === '') board = 2;
        else if (board3[0] === '') board = 3;
        else if (board4[0] === '') board = 4;
        else if (board5[0] === '') board = 5;
        
        if (board === 1) setBoard1(newBoard);
        if (board === 2) setBoard2(newBoard);
        if (board === 3) setBoard3(newBoard);
        if (board === 4) setBoard4(newBoard);
        if (board === 5) setBoard5(newBoard);
        
        if (!board) return setMessage('Error setting board');
        
        setMessage('');
        setGuesses([...guesses, normalizedGuess]);
        setGuess('');
        
        if (word === normalizedGuess) {
            setMessage(`You guessed the word! (${word})`);
            return clearWordleBoards();
        };
        
        if (board === 5) {
            setMessage('You failed to guess the word. :(');
            return clearWordleBoards();
        };
    };
    
    const clearWordleBoards = () => {
        setBoard1(['', '', '', '', '']);
        setBoard2(['', '', '', '', '']);
        setBoard3(['', '', '', '', '']);
        setBoard4(['', '', '', '', '']);
        setBoard5(['', '', '', '', '']);
        setWord(WordleWords[rNum(WordleWords.length - 1)].toUpperCase());
        setGuesses([]);
        setGuess('');
    };
    
    const getLetterStatuses = (letters) => {
        const remainingLetters = word.split('');
        const statuses = Array(letters.length).fill('absent');

        // Exact matches take priority, then remaining matching letters are marked present.
        letters.forEach((letter, index) => {
            if (letter && letter === word[index]) {
                statuses[index] = 'correct';
                remainingLetters[index] = null;
            }
        });

        letters.forEach((letter, index) => {
            if (!letter || statuses[index] === 'correct') return;

            const matchingIndex = remainingLetters.indexOf(letter);
            if (matchingIndex !== -1) {
                statuses[index] = 'present';
                remainingLetters[matchingIndex] = null;
            }
        });

        return statuses;
    };

    const showBoard = (board) => {
        const statuses = getLetterStatuses(board);

        return (
            board.map((el, i) => <div key={i} className='wordle-item'>
                <div className='wordle-letter-div'>
                    <p className={`wordle-p wordle-${el ? statuses[i] : 'empty'}`}>{el}</p>
                </div>
            </div>
            )
        );
    };
    
    const handleKeyDown = (e) => {
        if (e.key === 'Tab' || e.key === 'Enter') {
            e.preventDefault();
            handleSubmit();
        };
    };
    
    return (
        <div id='wordle-container'>
            <h2>Wordle</h2>
            <p id='wordle-green-p'>Green = Correct letter in the correct place.</p>
            <p id='wordle-yellow-p'>Yellow = Correct letter in the wrong place.</p>
            <p id='wordle-red-p'>Red = Letter is not in word.</p>
            
            <div id='wordle-board-tiles'>
                {showBoard(board1)}
                {showBoard(board2)}
                {showBoard(board3)}
                {showBoard(board4)}
                {showBoard(board5)}
            </div>
            
            <p id='wordle-info-message-p'>{message}</p>
            
            <div id='wordle-input-div'>
                <input type='text' id='wordle-guess-input'
                    value={guess}
                    onChange={(e) => setGuess(e.target.value.toUpperCase())}
                    minLength={5}
                    maxLength={5}
                    autoCapitalize='characters'
                    onKeyDown={(e) => handleKeyDown(e)}
                /><br></br>
                
                <button style={{marginTop: '10px'}} className='wordle-guess-button'
                    onClick={handleSubmit}
                >Submit</button>
            </div>
            
            
        </div>
    );
};

export default WordleComponent;
